
<template>
  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <router-view/>
  </main>
</template>
<script>

export default {
  name: "App",

};


</script>
<style>
/* odigo color aZUL:  #0083DF
Codigo color plata:  #C1C0C0
		                #707070
Codigo color verde: #0FC105 */
.btn-info {
    color: #000;
    background-color: #0083DF !important;
    border-color: #034472;
}
.navbar-vertical.bg-white .navbar-nav > .nav-item .nav-link.active {
    background-color: #0083DF !important;
    box-shadow: none;
}
.navbar-vertical .navbar-nav > .nav-item .nav-link.active {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.13);
}
</style>
